import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'uniqueBy',
    pure: true,
    standalone: false
})
export class UniqueByPipe implements PipeTransform {
  transform<T>(array: T[], key: keyof T): T[] {
    if (!Array.isArray(array)) return array;

    const seen = new Set();
    return array.filter(item => {
      const val = item[key];
      if (seen.has(val)) {
        return false;
      }
      seen.add(val);
      return true;
    });
  }
}
